import './ReportFormSectionConfig.scss';
import { FieldPath } from '@form-ts/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button } from 'src/modules/common/components/Button';
import { HorizontalDivider } from 'src/modules/common/components/HorizontalDivider';
import { sub } from 'src/modules/common/constants/formattingHelpers';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { Project } from 'src/modules/common/types/Project';
import { BodyMedium01 } from 'src/modules/common/typography/BodyMedium01';
import { LeadText } from 'src/modules/common/typography/LeadText';
import { CheckboxField } from 'src/modules/form/components/CheckboxField';
import { FormError } from 'src/modules/form/types/FormError';
import { ReportFormData } from 'src/modules/report/types/ReportFormData';
import { ReportFormFieldToggle } from 'src/modules/report/views/ReportFormFieldToggle';

type Props = {
  readonly field: FieldPath<ReportFormData, FormError, ReportFormData['evaluationCharts']>;
  readonly project: Project;
};

export const ReportFormSectionConfigEvaluationCharts = ({ field, project }: Props): React.ReactElement => (
  <div className="bp-report-form-section-config">
    <div className="bp-report-form-section-config__header">
      <BodyMedium01>
        <FormattedMessage id="report/form/evaluation/header"/>
      </BodyMedium01>

      <CheckboxField field={field.at('enabled')}/>
    </div>

    <HorizontalDivider/>

    <div className="bp-report-form-section-config__content">
      <ReportFormFieldToggle field={field.at('showBreakEvenPoint')}>
        <FormattedMessage id="report/form/evaluation/showBreakEvenPoint"/>
      </ReportFormFieldToggle>

      <ReportFormFieldToggle field={field.at('showAnnualCarbonEmmission')}>
        <FormattedMessage id="report/form/evaluation/showAnnualCarbonEmmission" values={{ sub }}/>
      </ReportFormFieldToggle>

      <ReportFormFieldToggle field={field.at('showReturnOnInvestment')}>
        <FormattedMessage id="report/form/evaluation/showReturnOnInvestment"/>
      </ReportFormFieldToggle>

      <ReportFormFieldToggle field={field.at('showInternalRateOfReturn')}>
        <FormattedMessage id="report/form/evaluation/showInternalRateOfReturn"/>
      </ReportFormFieldToggle>
    </div>

    <div className="bp-report-form-section-config__action">
      <Button
        fullWidth={true}
        as={Link}
        to={`/project/${encodeURIComponent(project.id)}/evaluation`}
        kind="tertiary"
        size="md"
      >
        <FormattedMessage id="report/form/evaluation/editLinkText"/>

        <div className="bp-report-form-section-config__button-icon">
          <ArrowRightIcon/>
        </div>
      </Button>
    </div>
  </div>
);
